export default (state = {}, action) => {
  switch (action.type) {
    case 'SETTINGS_SET':
      return action.settings;
    default:
      return state;
  }
};
